import { motion, AnimatePresence } from "framer-motion"
import PropTypes from "prop-types"
import * as styles from "@/styles/modules/DropdownNav.module.scss"

export default function DropdownNav({ children, isVisible, rightAligned }) {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.nav
          initial={{
            y: 10,
            opacity: 0,
            rotateX: "-10deg",
            transformOrigin: "center -20px",
            transformPerspective: 1000,
          }}
          animate={{ y: 0, opacity: 1, rotateX: "0deg" }}
          exit={{ y: 10, opacity: 0, rotateX: "-10deg" }}
          transition={{ ease: [0.3, 0, 0, 1], duration: 0.4 }}
          className={[
            styles.container,
            rightAligned ? styles.rightAligned : "",
          ].join(" ")}
        >
          {children}
        </motion.nav>
      )}
    </AnimatePresence>
  )
}

DropdownNav.defaultProps = {
  isVisible: false,
  rightAligned: false,
}

DropdownNav.propTypes = {
  isVisible: PropTypes.bool,
  rightAligned: PropTypes.bool,
}
